import { Fine } from 'utils/types';

export const isFineInSelection = (fine: Fine, selection: Fine[]) =>
  selection.some((selectedFine) => selectedFine.id === fine.id);

export const removeVisibleFines = (selection: Fine[], visibleFines: Fine[]) => {
  const visibleIds = new Set(visibleFines.map((fine) => fine.id));
  return selection.filter((fine) => !visibleIds.has(fine.id));
};

export const addVisibleFines = (selection: Fine[], visibleFines: Fine[]) => {
  const next = [...selection];
  const selectedIds = new Set(next.map((fine) => fine.id));

  visibleFines.forEach((fine) => {
    if (!selectedIds.has(fine.id)) {
      next.push(fine);
      selectedIds.add(fine.id);
    }
  });

  return next;
};
